/*--------------------------------------------------------------
# Custom scripts for template
--------------------------------------------------------------*/

const peopleFeedSliders = document.querySelectorAll('.people-feed-slider .swiper');

if (peopleFeedSliders.length > 0) {
    const peopleFeedSliderPagination = document.querySelectorAll('.people-feed-swiper-pagination');
    const peopleFeedSliderNext = document.querySelectorAll('.people-feed-swiper-next');
    const peopleFeedSliderPrev = document.querySelectorAll('.people-feed-swiper-prev');

    peopleFeedSliders.forEach((slider, i) => {
        // Add a dynamic class to each slider and its controls
        slider.classList.add('swiper-' + i);
        peopleFeedSliderPagination[i].classList.add('people-feed-swiper-pagination-' + i);
        peopleFeedSliderNext[i].classList.add('people-feed-swiper-next-' + i);
        peopleFeedSliderPrev[i].classList.add('people-feed-swiper-prev-' + i);

        // Initialize Swiper for each slider
        new Swiper('.people-feed-slider .swiper-' + i, {
            grabCursor: true,
            slidesPerView: 1.1,
            spaceBetween: 24,
            mousewheel: {
                enabled: true,
                releaseOnEdges: true,
                forceToAxis: true,
            },
            // Pagination toggle buttons
            pagination: {
                el: '.people-feed-swiper-pagination-' + i,
                clickable: true,
            },
            // Navigation arrows
            navigation: {
                nextEl: '.people-feed-swiper-next-' + i,
                prevEl: '.people-feed-swiper-prev-' + i,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                1200: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                1400: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                }
            }
        });
    });
}

